import React from 'react';
import type { PenaltyTier } from '@abs/shared-types';

export interface PenaltyCountdownProps {
  absencesToNextTier: number;
  nextTier: PenaltyTier | null;
}

export function PenaltyCountdown({
  absencesToNextTier,
  nextTier,
}: PenaltyCountdownProps): React.ReactElement | null {
  if (!nextTier) return null;

  return (
    <div className="penalty-countdown" role="status">
      <span className="penalty-countdown__number">{absencesToNextTier}</span>
      <span className="penalty-countdown__label">
        {absencesToNextTier === 1 ? 'absence' : 'absences'} until next penalty
      </span>
      <span className="penalty-countdown__tier">{nextTier.description}</span>
    </div>
  );
}
